import React, { useState, useEffect } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";  // برای هدایت به داشبورد

function UpdatePrices() {
  const [markets, setMarkets] = useState([]);
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(null); // برای شناسایی اینکه کدام بازار در حال ویرایش است
  const [updatedMarket, setUpdatedMarket] = useState({
    asset: "",
    ask: "",
    bid: "",
    isActive: true,
    buyIsActive: false,
    sellIsActive: true,
  });

  const navigate = useNavigate(); // استفاده از useNavigate برای هدایت به داشبورد

  // دریافت اطلاعات بازارها
  useEffect(() => {
    fetchMarkets();
  }, []);

  const fetchMarkets = async () => {
    try {
      const response = await axios.get("/Market");
      setMarkets(response.data.data);
    } catch (error) {
      setError("خطا در دریافت اطلاعات بازارها");
    }
  };

  // ارسال اطلاعات ویرایش‌شده به API
const handleUpdateMarket = async (marketId) => {
  try {

    const payload = {
      ...updatedMarket,
      ask: updatedMarket.ask.toString().replace(/,/g, ""),
      bid: updatedMarket.bid.toString().replace(/,/g, ""),
    };

    await axios.post("/Market", payload);

    setIsEditing(null);
    fetchMarkets();

  } catch (error) {
    setError("خطا در ارسال اطلاعات بازار");
  }
};

  const handleEditChange = (field, value) => {
    setUpdatedMarket((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const formatNumber = (value) => {
  if (value === null || value === undefined) return "";

  // حذف هر چیزی غیر از عدد
  const numericValue = value.toString().replace(/,/g, "").replace(/\D/g, "");

  if (!numericValue) return "";

  return Number(numericValue).toLocaleString("en-US");
};

const handlePriceChange = (field, value) => {
  const numericValue = value.replace(/,/g, "").replace(/\D/g, "");

  setUpdatedMarket((prev) => ({
    ...prev,
    [field]: numericValue,
  }));
};
const formatPrice = (value) => {
  if (value === null || value === undefined || value === "") return "";

  return Number(value).toLocaleString("en-US", {
    maximumFractionDigits: 8,
  });
};

  return (
    <div className="update-prices-container">
      {/* دکمه بازگشت به داشبورد */}
      <button className="back-button" onClick={() => navigate("/dashboard")}>
        بازگشت به داشبورد
      </button>

      <h2>بروزرسانی قیمت‌ها</h2>

      {error && <p className="error">{error}</p>}

      <div className="market-table">
        <table>
          <thead>
            <tr>
              <th>بازار</th>
              <th>قیمت خرید (ask)</th>
              <th>قیمت فروش (bid)</th>
              <th>فعال بودن</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {markets.map((market, index) => (
              <tr key={index}>
                <td>{market.asset}</td>

                {/* فیلدهای قیمت‌ها که ویرایش‌پذیر هستند */}
                <td>
                  {isEditing === market.asset ? (
                    <input
  type="text"
  inputMode="numeric"
  value={formatNumber(updatedMarket.ask)}
  onChange={(e) => handlePriceChange("ask", e.target.value)}
/>
                ) : (
  formatPrice(market.ask)
)}
                </td>

                <td>
                  {isEditing === market.asset ? (
             <input
  type="text"
  inputMode="numeric"
  value={formatNumber(updatedMarket.bid)}
  onChange={(e) => handlePriceChange("bid", e.target.value)}
/>
          ) : (
  formatPrice(market.bid)
)}
                </td>

                <td>
                  {isEditing === market.asset ? (
                    <>
                      <label>
                        فعال
                        <input
                          type="checkbox"
                          checked={updatedMarket.isActive}
                          onChange={() =>
                            handleEditChange("isActive", !updatedMarket.isActive)
                          }
                        />
                      </label>
                      <label>
                        خرید فعال
                        <input
                          type="checkbox"
                          checked={updatedMarket.buyIsActive}
                          onChange={() =>
                            handleEditChange("buyIsActive", !updatedMarket.buyIsActive)
                          }
                        />
                      </label>
                      <label>
                        فروش فعال
                        <input
                          type="checkbox"
                          checked={updatedMarket.sellIsActive}
                          onChange={() =>
                            handleEditChange("sellIsActive", !updatedMarket.sellIsActive)
                          }
                        />
                      </label>
                    </>
                  ) : (
                    <>
                      {market.isActive ? "بله" : "خیر"}
                    </>
                  )}
                </td>

                <td>
                  {isEditing === market.asset ? (
                    <button onClick={() => handleUpdateMarket(market.asset)}>ذخیره</button>
                  ) : (
                    <button onClick={() => {
                      setIsEditing(market.asset);
                      setUpdatedMarket({
                        asset: market.asset,
                        ask: market.ask,
                        bid: market.bid,
                        isActive: market.isActive,
                        buyIsActive: market.buyIsActive,
                        sellIsActive: market.sellIsActive,
                      });
                    }}>ویرایش</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UpdatePrices;
